import axios from 'axios';
import { UserGroup, UserGroupFormData, PaginatedUserGroupsResponse } from '../types/userGroup';
import { User } from '../types/user';

const API_URL = `${process.env.REACT_APP_API_URL}/user-groups`;

// الحصول على جميع مجموعات المستخدمين مع إمكانية التصفية والبحث
export const getUserGroups = async (
  page = 1,
  limit = 10,
  search = '',
  status = ''
): Promise<PaginatedUserGroupsResponse> => {
  const response = await axios.get(API_URL, {
    params: { page, limit, search, status }
  });
  return response.data;
};

// الحصول على مجموعة مستخدمين محددة بواسطة المعرف
export const getUserGroup = async (id: string): Promise<UserGroup> => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

// إنشاء مجموعة مستخدمين جديدة
export const createUserGroup = async (data: UserGroupFormData): Promise<UserGroup> => {
  const response = await axios.post(API_URL, data);
  return response.data;
};

// تحديث مجموعة مستخدمين موجودة
export const updateUserGroup = async (id: string, data: UserGroupFormData): Promise<UserGroup> => {
  const response = await axios.put(`${API_URL}/${id}`, data);
  return response.data;
};

// حذف مجموعة مستخدمين
export const deleteUserGroup = async (id: string): Promise<{ message: string }> => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};

// الحصول على المستخدمين في مجموعة محددة
export const getUsersInGroup = async (groupId: string): Promise<User[]> => {
  const response = await axios.get(`${API_URL}/${groupId}/users`);
  return response.data;
};

export const userGroupsApi = {
  getUserGroups,
  getUserGroup,
  createUserGroup,
  updateUserGroup,
  deleteUserGroup,
  getUsersInGroup
};